import axios, { AxiosError } from "axios";
import type { AxiosInstance, AxiosResponse } from "axios";
import { negociacionesGrupoEscalaApi } from "./negociacion-grupo-escalas.client";
import { setupAuthInterceptor } from "@/utils/setupAuthInterceptor";

const baseURL =
  import.meta.env.VITE_NEGOCIACIONES_UNIFICADOS_BACKEND_API_URL ||
  "http://localhost:4004/api";

const negociacionesUnificadosApi: AxiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
setupAuthInterceptor(negociacionesGrupoEscalaApi);

// Response interceptor for error handling
negociacionesUnificadosApi.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    return Promise.reject(error.response || "Algo salió mal");
  }
);

export { negociacionesUnificadosApi };
